import React, { useEffect, useRef, useState } from 'react'
// import { SocketProvider } from '../context/SocketContext';
import { useNavigate } from 'react-router-dom';
// import { LobbyRoutes } from '../routes/Routes';
// import ErrorBoundary from '../components/ErrorBoundary';
import { useDispatch, useSelector } from 'react-redux';
import { details, verify } from '../store/userAuthenticationSlice';

const ValidateUser = () => {
    const [params, setParams] = useState(null);
    const [token, setToken] = useState(null);
    const hasFetched = useRef(false);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { error } = useSelector((state) => state.userAuth);

    const authenticateUser = async (params) => {
        if (params.code && params.site_id && !hasFetched.current) {
            setLoading(true);
            hasFetched.current = true;
            try {
                const res = await dispatch(details(params)).unwrap();
                sessionStorage.clear();
                if (res?.detail?.token) {
                    sessionStorage.setItem("token", JSON.stringify(res?.detail?.token));
                    setToken(res?.detail?.token);
                    const response = await dispatch(verify(res?.detail?.token)).unwrap();
                    if (response) {
                        setLoading(false);
                        navigate("/lobby");
                    } else {
                        console.warn("User verification failed, staying on the same page.");
                        setLoading(false);
                    }
                } else {
                    console.warn("No token received from details API");
                    setLoading(false);
                }
            } catch (error) {
                console.error("Error fetching user details:", error);
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get("code");
        const site_id = urlParams.get("site_id");
        if (code && site_id) {
            setParams({ code, site_id });
            authenticateUser({ code, site_id });
        }
    }, []);

    const handleNavigate = () => {
        window.open(process.env.REACT_APP_WORLDSINGLES_APP_URL, "_self")
    }
    if (loading) {
        return (
            <div className="main-box">
                <div className="waiting-loader">
                    <h2>Verifying user please wait...</h2>
                    <div className="loader"></div>
                </div>
            </div>
        );
    } else if (error || params === null) {
        return (
            <div className="main-box">
                <div className="waiting-loader">
                    <h2>User Not Found</h2>
                    <button className="leave-btn" onClick={handleNavigate}>Return to Dashboard</button>
                </div>
            </div>
        )
    }
}

export default ValidateUser